import { Topic } from '../../location/topic/Topic';
import { App } from '../../app/App';
import { Actor } from '../../actor/Actor';
import { Path } from '../../location/path/Path';
import { AppOnlineCount } from '../../app/modules/AppOnlineCount';
import { Question } from '../../question/Question';
import { Answer } from '../../question/answer/Answer';
import { Choice } from '../../../questiontype/Choice/Choice';
import { Img } from '../../media/values/img/Img';
import { TTS } from '../../media/values/tts/TTS';
import { Snd } from '../../media/values/snd/Snd';
import { Vid } from '../../media/values/vid/Vid';
import { MedSeq } from '../../trait/valueClasses/MedSeq';
import { AspectExp } from '../../trait/valueClasses/AspectExp';
import { Aspect } from '../../aspect/Aspect';
import { TraitConditionLeftEvaluator } from '../../trait/evaluator/TraitConditionLeftEvaluator';
import { TraitConditionRightEvaluator } from '../../trait/evaluator/TraitConditionRightEvaluator';
import { Trait } from '../../trait/trait/Trait';
import { Bundle } from '../../bundle/Bundle';
import { QuestionCorrectWrong } from '../../../questiontype/CorrectWrong/QuestionCorrectWrong';
import { ConductType, MannerType, QuestionTypeName } from '../../learnware/LearnwareEnums';
import { AttachedImage } from '../../content/image/AttachedImage';
import { AttachedTrait } from '../../trait/attachedtrait/AttachedTrait';
import { TraitConditionEvaluator } from '../../trait/evaluator/TraitConditionEvaluator';
import { ChoiceOption } from '../../../questiontype/Choice/ChoiceOption/ChoiceOption';
import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
import { runtime } from '../Runtime';
import { Entity } from '../../entity/Entity';
import { AttachedText } from '../../content/text/AttachedText';
import { Model } from '../../model/Model';
import { Registry } from '../../../registry/Registry';
import { QuestionOrderedChoice } from '../../../questiontype/OrderedChoice/QuestionOrderedChoice';
import { Stage } from '../../stage/Stage';
import { QuestionMultipleChoice } from '../../../questiontype/MultipleChoice/QuestionMultipleChoice';
import { Aud } from '../../media/values/aud/Aud';
import { AttachedVideo } from '../../content/video/AttachedVideo';
import { QuestionIntro } from '../../../questiontype/Intro/QuestionIntro';
export class InjectedEntityClass {
    Model = Model;
    App = App;
    AttachedImage = AttachedImage;
    AttachedText = AttachedText;
    AttachedVideo = AttachedVideo;
    Question = Question;
    QuestionMultipleChoice = QuestionMultipleChoice;
    Choice = Choice;
    QuestionCorrectWrong = QuestionCorrectWrong;
    Entity = Entity;
    Actor = Actor;
    Aspect = Aspect;
    Trait = Trait;
    TraitConditionEvaluator = TraitConditionEvaluator;
    TraitConditionLeftEvaluator = TraitConditionLeftEvaluator;
    TraitConditionRightEvaluator = TraitConditionRightEvaluator;
    AttachedTrait = AttachedTrait;
    BasicOption = ChoiceOption;
    AttachedContent = AttachedContent;
    Bundle = Bundle;
    Registry = Registry;
    Img = Img;
    Answer = Answer;
    serialized_to_EntityClass(ser) {
        const { type } = ser;
        let Entity;
        if (type === 'path')
            return Path;
        if (type === 'topic')
            return Topic;
        if (type === 'stage')
            return Stage;
        if (type === 'bundle')
            return Bundle;
        if (type === 'answer') {
            return Answer;
        }
        if (type === 'onlinecounter')
            return AppOnlineCount;
        if (type === 'img') {
            return Img;
        }
        if (type === 'snd') {
            return Snd;
        }
        if (type === 'aud') {
            return Aud;
        }
        if (type === 'tts') {
            return TTS;
        }
        if (type === 'vid') {
            return Vid;
        }
        if (type === 'medseq') {
            return MedSeq;
        }
        if (type === 'aspectexp') {
            return AspectExp;
        }
        if (type === 'association') {
            return runtime.solidPackages.Rare.classes.Association;
        }
        if (type === 'question') {
            Entity = Question;
            if (ser.questionType === QuestionTypeName.MultipleChoice)
                return QuestionMultipleChoice;
            if (ser.questionType === QuestionTypeName.CorrectWrong)
                return QuestionCorrectWrong;
            if (ser.questionType === QuestionTypeName.Intro)
                return QuestionIntro;
            if (ser.questionType === QuestionTypeName.Read) {
                return runtime.solidPackages.Exotic.classes.QuestionRead;
            }
            if (ser.questionType === QuestionTypeName.Talk) {
                return runtime.solidPackages.Exotic.classes.QuestionTalk;
            }
            if (ser.questionType === QuestionTypeName.ThinkAndReveal) {
                return runtime.solidPackages.Rare.classes.QuestionThinkAndReveal;
            }
            if (ser.questionType === QuestionTypeName.Associate) {
                return runtime.solidPackages.Rare.classes.QuestionAssociate;
            }
            if (ser.questionType === QuestionTypeName.KnowAWord) {
                return runtime.solidPackages.Rare.classes.QuestionKnowAWord;
            }
            if (ser.questionType === QuestionTypeName.MemorizePoints) {
                return runtime.solidPackages.Rare.classes.QuestionMemorizePoints;
            }
            if (ser.questionType === QuestionTypeName.OrderedChoice)
                return QuestionOrderedChoice;
            if (ser.questionType === QuestionTypeName.Sortable) {
                return runtime.solidPackages.Rare.classes.QuestionSortable;
            }
            if (ser.questionType === QuestionTypeName.MultiSelect) {
                return runtime.solidPackages.Rare.classes.QuestionMultiSelect;
            }
            if (ser.questionType === QuestionTypeName.CycleEnd) {
                return runtime.solidPackages.Rare.classes.QuestionCycleEnd;
            }
        }
        if (type === 'trait') {
            return Trait;
        }
        if (type === 'manner') {
            const { MannerHearWord, MannerHearAnything, MannerPile } = runtime.solidPackages.Exotic.classes;
            if (ser.mannerType === MannerType.HearWord)
                return MannerHearWord;
            if (ser.mannerType === MannerType.HearAnything)
                return MannerHearAnything;
            if (ser.mannerType === MannerType.MannerPile)
                return MannerPile;
            return MannerHearWord;
        }
        if (type === 'conduct') {
            const { ConductSetQuestionCorrect, ConductSetQuestionWrong, ConductPlayMedia, ConductSetAnswerMark, } = runtime.solidPackages.Exotic.classes;
            if (ser.conductType === ConductType.SetQuestionCorrect)
                return ConductSetQuestionCorrect;
            if (ser.conductType === ConductType.SetQuestionWrong)
                return ConductSetQuestionWrong;
            if (ser.conductType === ConductType.SetAnswerMark)
                return ConductSetAnswerMark;
            if (ser.conductType === ConductType.PlayMedia)
                return ConductPlayMedia;
            return ConductSetQuestionCorrect;
        }
        return Entity;
    }
}
